// extracted by mini-css-extract-plugin
export default {"Box_0":"ValuePlaceholder-module__Box_0--sRIos","Box_1":"ValuePlaceholder-module__Box_1--AzhbD","Octicon_0":"ValuePlaceholder-module__Octicon_0--nMPaj"};